import {createAction} from "redux-act";
import {ActiveStep, IsFriendly, RequestState} from "modules/enums";
import {IFormError} from "modules/types";
import {IAnswer} from "modules/reducers";

export const requestLandingData = createAction();

export const setActiveStep = createAction<ActiveStep>();
export const clearGameError = createAction<IFormError>();
export const setAnswers = createAction<IAnswer[]>();

export const updateQuestionAnswer = createAction<IAnswer>();

export interface IRequestUserAnswerSuccessResponse {
	answers: IAnswer[];
	savedOptions: number[];
}

export const requestUserAnswers = createAction();
export const requestUserAnswersSuccess = createAction<IRequestUserAnswerSuccessResponse>();
export const requestUserAnswersFailed = createAction();

export interface ISaveUserAnswers {
	email: string;
	notification: boolean;
}

export interface ISaveUserAnswersSuccess {
	savedOptions: number[];
}

export const saveUserAnswers = createAction();
export const editUserAnswers = createAction();
export const saveUserAnswersSuccess = createAction<ISaveUserAnswersSuccess>();
export const saveUserAnswersFailed = createAction<IFormError>();

export const getIsFriendlyCountry = createAction();
export const getIsFriendlyCountrySuccess = createAction<IsFriendly>();
export const getIsFriendlyCountryFailed = createAction();

export const changeRequestState = createAction<RequestState>();

export const saveUnLoggedAnswers = createAction();

// Set the question to which the page should scroll
export const setAnchorId = createAction<number | null>();
